import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Typography, Grid, Container, TextField, Button, Paper } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AnimatedSection from '../components/AnimatedSection';
const contact = '/assets/contact.jpeg';

export default function ContactPage() {
  return (
    <Box>
      <Helmet>
        <title>Contact Splash Beauty Lounge | Salon in Asilmetta & Madhurawada, Vizag</title>
        <meta name="description" content="Book your appointment with Splash Beauty Lounge in Asilmetta and Madhurawada, Vizag. Call us for hair, skin, bridal and wellness services today." />
        <meta name="keywords" content="contact Splash Beauty Lounge, salon phone number Vizag, beauty parlour Asilmetta, salon Madhurawada, salon location Vizag, book salon appointment Vizag" />
      </Helmet>
      <Box
        sx={{
          position: 'relative',
          backgroundImage: `url(${contact})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          py: { xs: 8, md: 12 },
          textAlign: 'center',
          color: '#fff',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
          },
        }}
      >
        <Box sx={{ position: 'relative', zIndex: 1 }}>
          <Typography
            variant="h2"
            sx={{
              color: '#fff',
              fontFamily: '"Playfair Display", serif',
              fontSize: { xs: '2.5rem', md: '3.5rem' },
              mb: 1.5,
              textShadow: '0 2px 10px rgba(0,0,0,0.3)',
            }}
          >
            Contact Us
          </Typography>
          <Typography
            sx={{
              fontFamily: '"Lato", sans-serif',
              color: 'rgba(255,255,255,0.9)',
              fontSize: '1.1rem',
              maxWidth: '600px',
              mx: 'auto',
              px: 2,
            }}
          >
            Get in touch with us for appointments and inquiries
          </Typography>
        </Box>
      </Box>

      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Grid container spacing={5}>
          <Grid item xs={12} md={5}>
            <AnimatedSection>
              <Typography
                variant="h5"
                sx={{ fontFamily: '"Playfair Display", serif', color: '#1a1a1a', mb: 4 }}
              >
                Visit Us
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                {/* Branch 1: Asilmetta */}
                <Paper 
                  elevation={0} 
                  sx={{ 
                    border: '1px solid #eee', 
                    borderRadius: 2, 
                    p: 2.5,
                    transition: 'all 0.3s',
                    '&:hover': { borderColor: '#FF0099', boxShadow: '0 4px 15px rgba(255,0,153,0.08)' }
                  }}
                >
                  <Typography sx={{ fontFamily: '"Playfair Display", serif', fontWeight: 700, fontSize: '1.05rem', color: '#1a1a1a', mb: 1.5 }}>
                    Asilmetta Branch
                  </Typography>

                  <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center', mb: 1.5 }}>
                    <Box
                      sx={{
                        width: 38, height: 38, borderRadius: '50%',
                        backgroundColor: '#fff0f7',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                      }}
                    >
                      <PhoneIcon sx={{ color: '#FF0099', fontSize: '1.1rem' }} />
                    </Box>
                    <Box>
                      <Typography sx={{ fontFamily: '"Lato", sans-serif', fontSize: '0.75rem', color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                        Phone
                      </Typography>
                      <Typography 
                        component="a" 
                        href="tel:8977626223"
                        sx={{ fontFamily: '"Lato", sans-serif', fontSize: '0.9rem', color: '#333', fontWeight: 600, textDecoration: 'none', '&:hover': { color: '#FF0099' } }}
                      >
                        +91 89776 26223
                      </Typography>
                    </Box>
                  </Box>

                  <Box 
                    component="a"
                    href="https://maps.app.goo.gl/7r93iVAVRdYumT5n9"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start', textDecoration: 'none' }}
                  >
                    <Box
                      sx={{
                        width: 38, height: 38, borderRadius: '50%',
                        backgroundColor: '#fff0f7',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                      }}
                    >
                      <LocationOnIcon sx={{ color: '#FF0099', fontSize: '1.1rem' }} />
                    </Box>
                    <Box>
                      <Typography sx={{ fontFamily: '"Lato", sans-serif', fontSize: '0.75rem', color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                        Address (Tap for Map)
                      </Typography>
                      <Typography sx={{ fontFamily: '"Lato", sans-serif', fontSize: '0.88rem', color: '#444', lineHeight: 1.5, '&:hover': { color: '#FF0099' } }}>
                        Opp. Bombay Gaslight Stores, Asilmetta Junction, Visakhapatnam
                      </Typography>
                    </Box>
                  </Box>
                </Paper>

                {/* Branch 2: Madhurawada */}
                <Paper 
                  elevation={0} 
                  sx={{ 
                    border: '1px solid #eee', 
                    borderRadius: 2, 
                    p: 2.5,
                    transition: 'all 0.3s',
                    '&:hover': { borderColor: '#FF0099', boxShadow: '0 4px 15px rgba(255,0,153,0.08)' }
                  }}
                >
                  <Typography sx={{ fontFamily: '"Playfair Display", serif', fontWeight: 700, fontSize: '1.05rem', color: '#1a1a1a', mb: 1.5 }}>
                    Madhurawada Branch
                  </Typography>

                  <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center', mb: 1.5 }}>
                    <Box
                      sx={{
                        width: 38, height: 38, borderRadius: '50%',
                        backgroundColor: '#fff0f7',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                      }}
                    >
                      <PhoneIcon sx={{ color: '#FF0099', fontSize: '1.1rem' }} />
                    </Box>
                    <Box>
                      <Typography sx={{ fontFamily: '"Lato", sans-serif', fontSize: '0.75rem', color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                        Phone
                      </Typography>
                      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                        <Typography 
                          component="a" 
                          href="tel:9949788891"
                          sx={{ fontFamily: '"Lato", sans-serif', fontSize: '0.9rem', color: '#333', fontWeight: 600, textDecoration: 'none', '&:hover': { color: '#FF0099' } }}
                        >
                          +91 99497 88891
                        </Typography>
                        <Typography sx={{ color: '#aaa', fontSize: '0.9rem' }}>|</Typography>
                        <Typography 
                          component="a" 
                          href="tel:9949388891"
                          sx={{ fontFamily: '"Lato", sans-serif', fontSize: '0.9rem', color: '#333', fontWeight: 600, textDecoration: 'none', '&:hover': { color: '#FF0099' } }}
                        >
                          +91 99493 88891
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  <Box 
                    component="a"
                    href="https://share.google/V5E9UhEwGzjXTvJ0N"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start', textDecoration: 'none' }}
                  >
                    <Box
                      sx={{
                        width: 38, height: 38, borderRadius: '50%',
                        backgroundColor: '#fff0f7',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                      }}
                    >
                      <LocationOnIcon sx={{ color: '#FF0099', fontSize: '1.1rem' }} />
                    </Box>
                    <Box>
                      <Typography sx={{ fontFamily: '"Lato", sans-serif', fontSize: '0.75rem', color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                        Address (Tap for Map)
                      </Typography>
                      <Typography sx={{ fontFamily: '"Lato", sans-serif', fontSize: '0.88rem', color: '#444', lineHeight: 1.5, '&:hover': { color: '#FF0099' } }}>
                        Madhurawada, Visakhapatnam
                      </Typography>
                    </Box>
                  </Box>
                </Paper>

                {/* Working Hours */}
                <Paper elevation={0} sx={{ border: '1px solid #eee', borderRadius: 2, p: 2.5 }}>
                  <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center' }}>
                    <Box
                      sx={{
                        width: 38, height: 38, borderRadius: '50%',
                        backgroundColor: '#fff0f7',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                      }}
                    >
                      <AccessTimeIcon sx={{ color: '#FF0099', fontSize: '1.1rem' }} />
                    </Box>
                    <Box>
                      <Typography sx={{ fontFamily: '"Lato", sans-serif', fontWeight: 700, fontSize: '0.9rem', color: '#333', mb: 0.2 }}>
                        Hours
                      </Typography>
                      <Typography sx={{ fontFamily: '"Lato", sans-serif', fontSize: '0.85rem', color: '#777' }}>
                        Monday - Sunday: 9:00AM - 9:00PM
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
              </Box>
            </AnimatedSection>
          </Grid>

          <Grid item xs={12} md={7}>
            <AnimatedSection delay={0.15}>
              <Typography
                variant="h5"
                sx={{ fontFamily: '"Playfair Display", serif', color: '#1a1a1a', mb: 4 }}
              >
                Send Us a Message
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Your Name"
                      variant="outlined"
                      size="small"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          fontFamily: '"Lato", sans-serif',
                          borderRadius: 1.5,
                          '&:hover fieldset': { borderColor: '#FF0099' },
                          '&.Mui-focused fieldset': { borderColor: '#FF0099' },
                        },
                        '& .MuiInputLabel-root.Mui-focused': { color: '#FF0099' },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Phone Number"
                      variant="outlined"
                      size="small"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          fontFamily: '"Lato", sans-serif',
                          borderRadius: 1.5,
                          '&:hover fieldset': { borderColor: '#FF0099' },
                          '&.Mui-focused fieldset': { borderColor: '#FF0099' },
                        },
                        '& .MuiInputLabel-root.Mui-focused': { color: '#FF0099' },
                      }}
                    />
                  </Grid>
                </Grid>
                <TextField
                  fullWidth
                  label="Email Address"
                  variant="outlined"
                  size="small"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontFamily: '"Lato", sans-serif',
                      borderRadius: 1.5,
                      '&:hover fieldset': { borderColor: '#FF0099' },
                      '&.Mui-focused fieldset': { borderColor: '#FF0099' },
                    },
                    '& .MuiInputLabel-root.Mui-focused': { color: '#FF0099' },
                  }}
                />
                <TextField
                  fullWidth
                  label="Service of Interest"
                  variant="outlined"
                  size="small"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontFamily: '"Lato", sans-serif',
                      borderRadius: 1.5,
                      '&:hover fieldset': { borderColor: '#FF0099' },
                      '&.Mui-focused fieldset': { borderColor: '#FF0099' },
                    },
                    '& .MuiInputLabel-root.Mui-focused': { color: '#FF0099' },
                  }}
                />
                <TextField
                  fullWidth
                  label="Message"
                  variant="outlined"
                  multiline
                  rows={4}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontFamily: '"Lato", sans-serif',
                      borderRadius: 1.5,
                      '&:hover fieldset': { borderColor: '#FF0099' },
                      '&.Mui-focused fieldset': { borderColor: '#FF0099' },
                    },
                    '& .MuiInputLabel-root.Mui-focused': { color: '#FF0099' },
                  }}
                />
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: '#FF0099',
                    color: '#fff',
                    borderRadius: '25px',
                    py: 1.2,
                    fontSize: '0.95rem',
                    fontWeight: 700,
                    alignSelf: 'flex-start',
                    px: 4,
                    '&:hover': { backgroundColor: '#CC0077' },
                    boxShadow: '0 4px 15px rgba(255,0,153,0.3)',
                  }}
                >
                  Send Message
                </Button>
              </Box>
            </AnimatedSection>
          </Grid>
        </Grid>

        {/* Dual Branch Maps */}
        <Box sx={{ mt: 10 }}>
          <AnimatedSection>
            <Box sx={{ textAlign: 'center', mb: 5 }}>
              <Typography
                sx={{
                  fontFamily: '"Lato", sans-serif',
                  fontSize: '0.75rem',
                  color: '#FF0099',
                  letterSpacing: '0.25em',
                  textTransform: 'uppercase',
                  mb: 1,
                }}
              >
                OUR LOCATIONS
              </Typography>
              <Typography variant="h4" sx={{ color: '#1a1a1a', fontFamily: '"Playfair Display", serif', fontWeight: 700 }}>
                Find Our Branches
              </Typography>
            </Box>

            <Grid container spacing={4}>
              {/* Asilmetta Map */}
              <Grid item xs={12} md={6}>
                <Paper
                  elevation={0}
                  sx={{
                    border: '1px solid #eee',
                    borderRadius: 3,
                    p: 2.5,
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                  }}
                >
                  <Typography variant="h6" sx={{ fontFamily: '"Playfair Display", serif', fontWeight: 700, mb: 1, color: '#1a1a1a' }}>
                    Asilmetta Branch
                  </Typography>
                  <Typography sx={{ fontFamily: '"Lato", sans-serif', fontSize: '0.88rem', color: '#666', mb: 2 }}>
                    Opp. Bombay Gaslight Stores, Asilmetta Junction, Visakhapatnam
                  </Typography>
                  <Box
                    sx={{
                      width: '100%',
                      height: 320,
                      borderRadius: 2,
                      overflow: 'hidden',
                      mb: 2,
                      border: '1px solid #eee',
                    }}
                  >
                    <iframe
                      title="Splash Beauty Lounge Asilmetta"
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3800.0637174620584!2d83.3031023!3d17.7204481!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a3943477815d9cf%3A0x6a0e63712d9f4851!2sSplash%20Beauty%20Lounge!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </Box>
                  <Button
                    component="a"
                    href="https://maps.app.goo.gl/7r93iVAVRdYumT5n9"
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="outlined"
                    fullWidth
                    sx={{
                      borderColor: '#FF0099',
                      color: '#FF0099',
                      borderRadius: '25px',
                      textTransform: 'none',
                      fontWeight: 600,
                      '&:hover': { backgroundColor: '#fff0f7', borderColor: '#FF0099' },
                    }}
                  >
                    Open in Google Maps
                  </Button>
                </Paper>
              </Grid>

              {/* Madhurawada Map */}
              <Grid item xs={12} md={6}>
                <Paper
                  elevation={0}
                  sx={{
                    border: '1px solid #eee',
                    borderRadius: 3,
                    p: 2.5,
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                  }}
                >
                  <Typography variant="h6" sx={{ fontFamily: '"Playfair Display", serif', fontWeight: 700, mb: 1, color: '#1a1a1a' }}>
                    Madhurawada Branch
                  </Typography>
                  <Typography sx={{ fontFamily: '"Lato", sans-serif', fontSize: '0.88rem', color: '#666', mb: 2 }}>
                    Madhurawada, Visakhapatnam
                  </Typography>
                  <Box
                    sx={{
                      width: '100%',
                      height: 320,
                      borderRadius: 2,
                      overflow: 'hidden',
                      mb: 2,
                      border: '1px solid #eee',
                    }}
                  >
                    <iframe
                      title="Splash Beauty Lounge Madhurawada"
                      src="https://maps.google.com/maps?q=Splash+Beauty+Lounge+Madhurawada+Visakhapatnam&t=&z=15&ie=UTF8&iwloc=&output=embed"
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </Box>
                  <Button
                    component="a"
                    href="https://share.google/V5E9UhEwGzjXTvJ0N"
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="outlined"
                    fullWidth
                    sx={{
                      borderColor: '#FF0099',
                      color: '#FF0099',
                      borderRadius: '25px',
                      textTransform: 'none',
                      fontWeight: 600,
                      '&:hover': { backgroundColor: '#fff0f7', borderColor: '#FF0099' },
                    }}
                  >
                    Open in Google Maps
                  </Button>
                </Paper>
              </Grid>
            </Grid>
          </AnimatedSection>
        </Box>
      </Container>
    </Box>
  );
}